import React, { useState } from "react";

export default function QuantumAccessPopup({ onClose }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = () => {
    // For now, always invalid
    setError("❗ Invalid Quantum Code");
  };

  return (
    <div className="quantum-popup-overlay">
      <div className="quantum-popup">
        <h2>Restricted Access</h2>
        <p>More qubits are accessible only for <strong>Degen Den Academy Members</strong>.</p>

        <label htmlFor="quantum-code" style={{alignContent:'center', justifyContent:'center'}}> 🔒 </label>
        <input
          id="quantum-code"
          type="text"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Enter your Quantum code…"
        />

        {error && <div className="popup-error">{error}</div>}

        <div className="popup-buttons">
          <button onClick={handleSubmit}>Submit</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
